import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../../lib/supabase'

export default function Sitemap() {
  const navigate = useNavigate()

  useEffect(() => {
    const generateSitemap = async () => {
      try {
        const baseUrl = 'https://www.plazaaurora.pe'
        
        // Static pages
        const staticPages = [
          { loc: `${baseUrl}/`, changefreq: 'daily', priority: '1.0', lastmod: new Date().toISOString().split('T')[0] },
          { loc: `${baseUrl}/marcas`, changefreq: 'daily', priority: '0.9', lastmod: new Date().toISOString().split('T')[0] },
          { loc: `${baseUrl}/eventos`, changefreq: 'daily', priority: '0.9', lastmod: new Date().toISOString().split('T')[0] },
          { loc: `${baseUrl}/ubicanos`, changefreq: 'weekly', priority: '0.7', lastmod: new Date().toISOString().split('T')[0] },
          { loc: `${baseUrl}/contacto`, changefreq: 'monthly', priority: '0.6', lastmod: new Date().toISOString().split('T')[0] },
          { loc: `${baseUrl}/trabaja`, changefreq: 'monthly', priority: '0.6', lastmod: new Date().toISOString().split('T')[0] },
          { loc: `${baseUrl}/legal`, changefreq: 'yearly', priority: '0.3', lastmod: new Date().toISOString().split('T')[0] },
        ]

        // Dynamic pages - Tiendas
        const { data: tiendas } = await db.getTiendas()
        const tiendaPages = tiendas?.filter(t => t.publicado && t.robots_index !== false).map(tienda => ({
          loc: `${baseUrl}/marcas/${tienda.id}`,
          changefreq: 'weekly',
          priority: '0.8',
          lastmod: tienda.updated_at ? new Date(tienda.updated_at).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]
        })) || []

        // Dynamic pages - Eventos
        const { data: eventos } = await db.getEventos()
        const eventoPages = eventos?.filter(e => e.publicado && e.robots_index !== false && e.estado === 'Activo').map(evento => ({
          loc: `${baseUrl}/eventos/${evento.id}`,
          changefreq: 'daily',
          priority: '0.8',
          lastmod: evento.updated_at ? new Date(evento.updated_at).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]
        })) || []

        const allPages = [...staticPages, ...tiendaPages, ...eventoPages]

        // Generate XML
        const xmlContent = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${allPages.map(page => `  <url>
    <loc>${page.loc}</loc>
    <lastmod>${page.lastmod}</lastmod>
    <changefreq>${page.changefreq}</changefreq>
    <priority>${page.priority}</priority>
  </url>`).join('\n')}
</urlset>`

        // Download sitemap
        const blob = new Blob([xmlContent], { type: 'application/xml' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'sitemap.xml'
        link.click()
        URL.revokeObjectURL(url)
        
        // Redirect after download
        setTimeout(() => navigate('/'), 1000)
      } catch (error) {
        console.error('Error generating sitemap:', error)
        navigate('/')
      }
    }

    generateSitemap()
  }, [navigate])

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '4rem auto', 
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ fontFamily: 'var(--font-display)', marginBottom: '1rem' }}>
        Generando sitemap.xml...
      </h1>
      <p style={{ color: 'var(--color-text-muted)' }}>
        Tu descarga comenzará en un momento.
      </p>
    </div>
  )
}
